import React, { useCallback, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import { requiredValidator } from "../../components/formFields/CommonValidator";
// import FormTextField from "../../components/formFields/FormTextField";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { useLocation } from "react-router-dom";

const AttractionNearbyArray = (
  fieldArrayRenderProps: FieldArrayRenderProps,
) => {
  const dispatch = useAppDispatch();
  const [deleteIndex, setDeleteIndex] = useState(-1);
  const location = useLocation();
  const AttractionsID = location.state?.AttractionsID;
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const AttractionsList = useAppSelector(
    (state) => state.attractions.AttractionsList,
  );
  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("deleteAttractionNearby"));
    setDeleteIndex(index);
  };
  const handleDeleteAction = useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      setDeleteIndex(-1);
    },
    [fieldArrayRenderProps],
  );
  const pushElementInarray = useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        Title: "",
        Description: "",
      },
    });
  }, [fieldArrayRenderProps]);
  // if (!fieldArrayRenderProps?.value?.length) {
  //   pushElementInarray();
  // }

  return (
    <>
      <GridLayoutItem
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography.h4>Add Near By Attraction</Typography.h4>
        <div>
          <Button
            fillMode={"solid"}
            themeColor={"primary"}
            onClick={pushElementInarray}
            type="button"
          >
            Add New
          </Button>
        </div>
      </GridLayoutItem>

      {dialogName === "deleteAttractionNearby" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Near By Attraction"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Near By Attraction?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(deleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      <GridLayoutItem
        style={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GridLayout
          style={{ marginRight: 10 }}
          gap={{ rows: 10, cols: 10 }}
          cols={[{ width: "50%" }, { width: "50%" }]}
        >
          {fieldArrayRenderProps.value &&
            fieldArrayRenderProps.value.length > 0 &&
            fieldArrayRenderProps.value?.map((Nearby: any, index: number) => (
              <div
                key={index}
                style={{
                  padding: "0 20px 20px 20px",
                  border: "1px solid orange",
                  borderRadius: 8,
                }}
              >
                <div>
                  <Field
                    name={`Nearby.${index}.SelectedAttractionID`}
                    label="Attraction"
                    placeholder="Category"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={AttractionsList?.filter(
                      (crnt) => crnt.ID !== AttractionsID,
                    )?.map((attr) => ({
                      label: attr?.Title,
                      value: attr?.ID,
                    }))}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <Field
                    name={`Nearby.${index}.KmAwayFromMainAttraction`}
                    label="Km Away"
                    component={FormNumericTextField}
                    validator={requiredValidator}
                    wrapperClassName="w-100"
                    astrike={true}
                    rows={2}
                  />
                  <IconButton
                    onClick={() => handleOpenDeleteDialog(index)}
                    // disabled={fieldArrayRenderProps?.value?.length === 1}
                    themeColor={"error"}
                    size={"small"}
                    fillMode={"solid"}
                    type="button"
                    style={{
                      marginTop: 35,
                      height: 30,
                      width: 30,
                    }}
                    icon={MdDelete}
                    iconClassName="absolute-position"
                    iconStyle={{ fontSize: "24px" }}
                  />
                </div>
              </div>
            ))}
        </GridLayout>
      </GridLayoutItem>
    </>
  );
};

export default AttractionNearbyArray;
